module.exports = __webpack_public_path__ + "img/chubova_500.ecf18b5c.jpg";